import { MainLayout } from '@/shared/layouts/ui/MainLayout';
import { Button } from '@/shared/ui/Button';
import { Typography } from '@/shared/ui/Typography/Typography';

import LinkArrowIcon from '@/assets/icons/linkArrow.svg?react';
import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {

    const navigate = useNavigate();

    const handleRedirect = () => {
        navigate('/', { replace: true })
    }

    return (
        <MainLayout>
            <section className='w-full py-[80px]'>
                <div className='container flex flex-col px-[10px] md:px-[32px] gap-[20px] md:gap-[40px]'>
                    <div className="
                        flex justify-center items-center w-full h-[300px]
                        bg-center bg-no-repeat bg-[length:80%_90%] bg-[url('/images/404.svg')]
                    ">
                        <Typography className='text-[24px] md:text-[32px] text-center font-semibold'>
                            Ой, кажется, мы потеряли эту страницу!
                        </Typography>
                    </div>
                    <div className='flex flex-col gap-[20px] items-center'>
                        <Typography className='text-center text-[16px] md:text-[20px] md:font-semibold'>
                            Но не волнуйтесь, у нас есть тысячи отличных объектов, которые точно найдутся. Давайте перейдем на главную и продолжим поиск!
                        </Typography>
                        <Button
                            text='На главную'
                            bg='black'
                            endIcon={<LinkArrowIcon className='h-[30px] w-[30px]' />}
                            className='normal h-[38px] md:h-[42px] w-full md:w-[355px] pr-[4px] pl-[16px] md:pl-[24px] md:pr-[6px] font-[400] text-[16px]'
                            onClick={handleRedirect}
                        />
                    </div>
                </div>
            </section>
        </MainLayout>
    )
}

